import * as React from "react";
import { IconAnglesRight } from "components/icons";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";


export const IconButtonArrowRight: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonAdd.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconAnglesRight fixedWidth  />
            {children}
        </MprcIconButton>
    );
};
